import { Table, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useLowStock } from '@hooks/useInventory';
import type { LowStockItem } from '@/types/inventory';

export default function LowStockPage() {
  const { data: mdLowStockItems, isLoading: mdIsLoading } = useLowStock();

  const mdGetRowClassName = (mdRecord: LowStockItem): string => {
    if (mdRecord.minStockLevel > 0) {
      const mdDeficitPercent = mdRecord.deficit / mdRecord.minStockLevel;
      if (mdDeficitPercent > 0.5) return 'md-row-deficit-critical';
      if (mdDeficitPercent > 0) return 'md-row-deficit-warning';
    }
    return '';
  };

  const mdColumns: ColumnsType<LowStockItem> = [
    {
      title: 'SKU',
      dataIndex: 'sku',
      key: 'sku',
      width: 140,
      sorter: (mdA, mdB) => mdA.sku.localeCompare(mdB.sku),
    },
    {
      title: 'Назва',
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
      sorter: (mdA, mdB) => mdA.productName.localeCompare(mdB.productName),
    },
    {
      title: 'Поточний залишок',
      dataIndex: 'currentStock',
      key: 'currentStock',
      width: 160,
      align: 'right',
      sorter: (mdA, mdB) => mdA.currentStock - mdB.currentStock,
    },
    {
      title: 'Мінімум',
      dataIndex: 'minStockLevel',
      key: 'minStockLevel',
      width: 120,
      align: 'right',
    },
    {
      title: 'Дефіцит',
      dataIndex: 'deficit',
      key: 'deficit',
      width: 120,
      align: 'right',
      sorter: (mdA, mdB) => mdA.deficit - mdB.deficit,
      defaultSortOrder: 'descend',
      render: (mdValue: number) => (
        <span style={{ color: mdValue > 0 ? '#ff4d4f' : '#52c41a', fontWeight: 600 }}>
          {mdValue > 0 ? `-${mdValue}` : '0'}
        </span>
      ),
    },
  ];

  return (
    <>
      <Typography.Title level={4} style={{ marginBottom: 16 }}>
        Мінімальні залишки
      </Typography.Title>

      <style>{`
        .md-row-deficit-critical { background-color: #fff1f0 !important; }
        .md-row-deficit-critical:hover > td { background-color: #ffccc7 !important; }
        .md-row-deficit-warning { background-color: #fff7e6 !important; }
        .md-row-deficit-warning:hover > td { background-color: #ffe7ba !important; }
      `}</style>

      <Table<LowStockItem>
        columns={mdColumns}
        dataSource={mdLowStockItems}
        rowKey="productId"
        loading={mdIsLoading}
        rowClassName={mdGetRowClassName}
        pagination={{
          showSizeChanger: true,
          showTotal: (mdTotal) => `Всього: ${mdTotal}`,
        }}
        size="middle"
      />
    </>
  );
}
